module.exports = __webpack_public_path__ + "img/couples-077.2d1728b7.jpg";